import { createSlice } from '@reduxjs/toolkit';

const initialState = { value: [] };

export const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setSettings: (state, action) => {
      state.value = action.payload;
    }
  }
});

export const { setSettings } = settingsSlice.actions;
export default settingsSlice.reducer;